import { render, staticRenderFns } from "./ChannelSpacerAdd.vue?vue&type=template&id=4c97224e&scoped=true&lang=html"
import script from "./ChannelSpacerAdd.vue?vue&type=script&lang=js"
export * from "./ChannelSpacerAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c97224e",
  null
  
)

export default component.exports